export const SENT_PHOTO_DELETE_LABEL = 'Supprimer';
export const SENT_PHOTO_DELETE_CONFIRM = 'Supprimer cette photo du rapport ? Elle sera retirée du rapport et des archives.';

/** Auteur, repreneur et admins seulement. Le serveur refuse les autres. */
export function sentPhotoActions(canWrite) {
  if (!canWrite) return { canDelete: false, label: '', confirm: '' };
  return {
    canDelete: true,
    label: SENT_PHOTO_DELETE_LABEL,
    confirm: SENT_PHOTO_DELETE_CONFIRM,
  };
}
